<template>
  <div class="page-wrapper-table">
    <div class="page-wrapper-table-header">
      <el-select
        class="select-primary pagination-select"
        v-model="pagination.perPage"
        :placeholder="$t('COMMON.PER_PAGE')"
      >
        <el-option
          class="select-primary"
          v-for="item in pagination.perPageOptions"
          :key="item"
          :label="item"
          :value="item"
        >
        </el-option>
      </el-select>

      <organization-selector
        v-if="
          !filterOrganization &&
          $currentUserCan($permissions.PERM_VIEW_ANY_ORGANIZATIONS)
        "
        @organizationChanged="
          (organizationId) => (selectedOrganization = organizationId)
        "
      />

      <type-mail-selector
        :showAll="true"
        :allowNone="true"
        :filterable="true"
        @typeMailChanged="
          (typeMailId, typeMail) => {
            selectedTypeMail = typeMailId;
          }
        "
      />

      <base-input
        v-model="query"
        type="search"
        prepend-icon="fas fa-search"
        :placeholder="$t('COMMON.SEARCH')"
        clearable
      />
    </div>
    <div class="page-wrapper-table-body">
      <div class="page-wrapper-table-body-inner">
        <el-table
          class="align-items-center table-flush"
          header-row-class-name="thead-light"
          :data="templatesMails"
          @sort-change="sortChange"
        >
          <div class="table-loading" slot="empty" v-if="loading">
            <img src="/img/loading.gif" />
          </div>
          <el-table-column
            :label="$t('TEMPLATES_MAILS.TITLE')"
            min-width="220"
            sortable="custom"
          >
            <template v-slot="{ row }">
              {{ row.title }}
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('TEMPLATES_MAILS.SUBJECT')"
            min-width="220"
            sortable="custom"
          >
            <template v-slot="{ row }">
              {{ row.subject }}
            </template>
          </el-table-column>
          <!-- <el-table-column
            :label="$t('TEMPLATES_INVOICES.IS_DEFAULT_TEMPLATE')"
            min-width="220"
            sortable="custom"
          >
            <template v-slot="{ row }">
              {{ row.is_default ? $t('COMMON.YES') : $t('COMMON.NO')  }}
            </template>
          </el-table-column> -->
          <el-table-column
            :label="$t('TEMPLATES_MAILS.FROM')"
            min-width="220"
            sortable="custom"
          >
            <template v-slot="{ row }">
              {{ row.from?.email }}
            </template>
          </el-table-column>

          <el-table-column
            :label="$t('COMMON.ORGANIZATION')"
            min-width="220"
            v-if="
              !filterOrganization &&
              $currentUserCan($permissions.PERM_VIEW_ANY_ORGANIZATIONS)
            "
          >
            <template v-slot="{ row }">
              <organization :organization="row.organization" />
            </template>
          </el-table-column>

          <el-table-column
            :label="$t('COMMON.CREATED_AT')"
            prop="created_at"
            sortable="custom"
            min-width="220"
          >
            <template v-slot="{ row }">
              {{ $formatDate(row.created_at) }}
            </template>
          </el-table-column>

          <el-table-column fixed="right" min-width="120">
            <div slot-scope="{ row }" class="table-actions">
              <el-tooltip
                :content="$t('COMMON.VIEW')"
                placement="top"
                v-if="$currentUserCan($permissions.PERM_VIEW_TEMPLATES_MAILS)"
              >
                <a
                  type="text"
                  @click="viewTemplateMail(row)"
                  class="table-action"
                  data-toggle="tooltip"
                  style="cursor: pointer"
                >
                  <i class="fal fa-expand-alt"></i>
                </a>
              </el-tooltip>

              <el-tooltip
                :content="$t('COMMON.EDIT')"
                placement="top"
                v-if="$currentUserCan($permissions.PERM_EDIT_TEMPLATES_MAILS)"
              >
                <a
                  type="text"
                  @click="editTemplateMail(row)"
                  class="table-action"
                  data-toggle="tooltip"
                  style="cursor: pointer"
                >
                  <i class="fal fa-edit"></i>
                </a>
              </el-tooltip>

              <el-tooltip
                :content="$t('TEMPLATES_MAILS.CLONE')"
                placement="top"
                v-if="$currentUserCan($permissions.PERM_CREATE_TEMPLATES_MAILS)"
              >
                <a
                  type="text"
                  @click="cloneTemplateMail(row)"
                  class="table-action"
                  data-toggle="tooltip"
                  style="cursor: pointer"
                >
                  <i class="fal fa-copy"></i>
                </a>
              </el-tooltip>

              <el-tooltip
                content="Delete"
                placement="top"
                v-if="$currentUserCan($permissions.PERM_DELETE_TEMPLATES_MAILS)"
              >
                <a
                  type="text"
                  @click="deleteTemplateMail(row)"
                  class="table-action table-action-delete"
                  data-toggle="tooltip"
                  style="cursor: pointer"
                >
                  <i class="fal fa-trash-alt"></i>
                </a>
              </el-tooltip>
            </div>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="page-wrapper-table-footer">
      <p class="card-category">
        {{
          $t("COMMON.DISPLAY_FROM_X_TO_X_OF_X_ENTRIES", {
            from: total ? from + 1 : 0,
            to: to,
            of: total,
          })
        }}

        <span v-if="selectedRows.length">
          &nbsp; &nbsp;
          {{ $t("COMMON.X_LINES_SELECTED", { count: selectedRows.length }) }}
        </span>
      </p>
      <base-pagination
        class="pagination-no-border"
        v-model="pagination.currentPage"
        :per-page="pagination.perPage"
        :total="total"
      />
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  Button,
} from "element-ui";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import requestErrorMixin from "@/mixins/request-error-mixin";
import { BasePagination } from "@/components";
import TypeMailSelector from "@/components/TypeMailSelector.vue";
import OrganizationSelector from "@/components/OrganizationSelector.vue";
import { mapGetters } from "vuex";

export default {
  name: "template-mail-list-table",

  components: {
    BasePagination,
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    TypeMailSelector,
    OrganizationSelector,
  },

  mixins: [requestErrorMixin],

  props: {
    filterOrganization: {
      type: String,
      default: null,
      description: "organization id",
    },
  },

  data() {
    return {
      query: null,
      tracking_number: null,
      selectedRows: [],
      sort: "-created_at",
      total: 0,
      title: null,
      pagination: {
        perPage: 20,
        currentPage: 1,
        perPageOptions: [20, 50, 100, 500],
      },
      templatesMails: [],
      loading: true,
      dateRange: null,
      selectedOrganization: null,
      selectedTypeMail: null,
      selectOrganizationId: null,
    };
  },

  computed: {
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },

    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
  },

  watch: {
    query: {
      handler: "getListDebounced",
      immediate: true,
    },
    pagination: {
      handler: "getList",
      immediate: false,
      deep: true,
    },
    filterOrganization: {
      handler: "getListDebounced",
      immediate: true,
    },
    selectedOrganization: {
      handler: "getListDebounced",
      immediate: true,
    },
    dateRange: {
      handler: "getListDebounced",
      immediate: false,
      deep: true,
    },
    selectedTypeMail: {
      handler: "getListDebounced",
      immediate: true,
    },
  },

  methods: {
    getListDebounced: _.debounce(function () {
      this.getList();
    }, 300),

    async getList() {
      try {
        this.loading = true;
        let params = {
          ...(this.sort ? { sort: this.sort } : {}),
          filter: {
            ...(this.query ? { search: this.query } : {}),
          },
          page: {
            number: this.pagination.currentPage,
            size: this.pagination.perPage,
          },
          include: "organization",
        };

        if (this.filterOrganization) {
          params = {
            ...params,
            filter: { ...params.filter, organization: this.filterOrganization },
          };
        }
        if (this.selectedOrganization) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              organization: this.selectedOrganization,
            },
          };
        }

        if (this.selectedTypeMail) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              typeMail: this.selectedTypeMail,
            },
          };
        }

        await this.$store.dispatch("templateMails/list", params);
        this.templatesMails = this.$store.getters["templateMails/list"];
        this.total = this.$store.getters["templateMails/listTotal"];
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },

    cloneTemplateMail(templateMail) {
      this.$emit("onCloneTemplateMail", templateMail);
    },

    deleteTemplateMail(templateMail) {
      this.$emit("onDeleteTemplateMail", templateMail);
    },

    viewTemplateMail(templateMail) {
      this.$emit("onViewTemplateMail", templateMail);
    },

    editTemplateMail(templateMail) {
      this.$emit("onEditTemplateMail", templateMail);
    },

    sortChange({ prop, order }) {
      if (order === "descending") {
        this.sort = `-${prop}`;
      } else {
        this.sort = `${prop}`;
      }
      this.getList();
    },
  },
};
</script>
